/**
 * PDP media gallery — Workshop Manual Hub.
 *
 * UX lock (PDF workshop-manual PDP): combined hero + thumbs + arrows + lightbox.
 * Thumbnail click / prev-next swap the in-page hero; hero click opens a dialog
 * zoom (PDF sample text is too small to read at thumb size). Keyboard: Left/
 * Right in the gallery or lightbox, Escape closes the dialog.
 */
(function () {
  var SELECTOR = '[data-wmh-gallery]';

  function slidesFrom(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-wmh-slide]')).map(function (btn) {
      return {
        btn: btn,
        src: btn.getAttribute('data-src') || '',
        srcset: btn.getAttribute('data-srcset') || '',
        sizes: btn.getAttribute('data-sizes') || '',
        alt: btn.getAttribute('data-alt') || '',
        label: btn.getAttribute('data-label') || btn.getAttribute('aria-label') || '',
      };
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-wmh-ready') === '1') return;
    var slides = slidesFrom(root);
    if (!slides.length) return;
    root.setAttribute('data-wmh-ready', '1');

    var heroImg = root.querySelector('[data-wmh-hero-img]') || root.querySelector('.wmh-pdp__cover img');
    var live = root.querySelector('[data-wmh-live]');
    var zoomBtn = root.querySelector('[data-wmh-zoom]');
    var prevBtn = root.querySelector('[data-wmh-prev]');
    var nextBtn = root.querySelector('[data-wmh-next]');
    var dialog = root.querySelector('[data-wmh-lightbox]');
    var dialogImg = dialog && dialog.querySelector('[data-wmh-lightbox-img]');
    var dialogClose = dialog && dialog.querySelector('[data-wmh-lightbox-close]');
    var dialogPrev = dialog && dialog.querySelector('[data-wmh-lightbox-prev]');
    var dialogNext = dialog && dialog.querySelector('[data-wmh-lightbox-next]');
    var index = 0;

    function announce() {
      if (!live) return;
      var n = index + 1;
      var total = slides.length;
      var label = slides[index].label || slides[index].alt || 'Preview';
      live.textContent = 'Preview ' + n + ' of ' + total + ': ' + label;
    }

    function setIndex(next, opts) {
      var total = slides.length;
      if (!total) return;
      index = ((next % total) + total) % total;
      var slide = slides[index];
      if (heroImg) {
        heroImg.src = slide.src;
        if (slide.srcset) heroImg.srcset = slide.srcset;
        if (slide.sizes) heroImg.sizes = slide.sizes;
        heroImg.alt = slide.alt;
      }
      if (dialogImg) {
        dialogImg.src = slide.src;
        if (slide.srcset) dialogImg.srcset = slide.srcset;
        dialogImg.alt = slide.alt;
      }
      slides.forEach(function (s, i) {
        var on = i === index;
        s.btn.setAttribute('aria-current', on ? 'true' : 'false');
        s.btn.classList.toggle('is-current', on);
      });
      if (zoomBtn) {
        zoomBtn.setAttribute(
          'aria-label',
          'View larger: ' + (slide.label || slide.alt || 'preview') + ' (' + (index + 1) + ' of ' + total + ')'
        );
      }
      announce();
      if (opts && opts.focusThumb) {
        slide.btn.focus();
      }
    }

    function step(delta, opts) {
      setIndex(index + delta, opts);
    }

    function openLightbox() {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      if (dialogClose) dialogClose.focus();
    }

    function closeLightbox() {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      if (zoomBtn) zoomBtn.focus();
    }

    function isLightboxOpen() {
      return !!(dialog && (dialog.open || dialog.hasAttribute('open')));
    }

    slides.forEach(function (s, i) {
      s.btn.addEventListener('click', function () {
        setIndex(i);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    if (zoomBtn) zoomBtn.addEventListener('click', openLightbox);
    if (dialogClose) dialogClose.addEventListener('click', closeLightbox);
    if (dialogPrev) dialogPrev.addEventListener('click', function () { step(-1); });
    if (dialogNext) dialogNext.addEventListener('click', function () { step(1); });

    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeLightbox();
      });
      dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeLightbox();
      });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target.closest('dialog') && !isLightboxOpen()) return;
      var inGallery = root.contains(e.target);
      if (!inGallery && !isLightboxOpen()) return;
      e.preventDefault();
      step(e.key === 'ArrowLeft' ? -1 : 1, { focusThumb: !isLightboxOpen() && e.target.hasAttribute('data-wmh-slide') });
    });

    setIndex(0);
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
